const EventRouter = {
  path: '/event',
  name: 'Event',
  redirect: '/event/activity',
  component: () => import('@/views/match/index'),
  children: [
    {
      path: 'activity',
      name: 'EventActivity',
      component: () => import('@/views/event/activity'),
      meta: {
        title: '活动详情'
      }
    },
    {
      path: 'activity-anar',
      name: 'EventActivityAnar',
      component: () => import('@/views/event/activity-anar'),
      meta: {
        title: '活动详情'
      }
    }
  ]
}
export default EventRouter
